<script setup>
import PillCheckbox from "@/components/global-themed/buttons/PillCheckbox.vue";
import {useStore} from "vuex";
import {computed, watch} from "vue";
import {getActions} from "@/composables/useActions";
import _ from "lodash";
import CustomMultiselect from "@/components/global-themed/CustomMultiselect.vue";

const store = useStore();
const activeTab = computed(() => store?.getters['actions/activeTab']);
const monthsFilter = computed({
  get: () => store?.getters['actions/monthsFilter'],
  set: (newValue) => store?.dispatch('actions/setMonthsFilter', newValue),
});

const {data: completedActionsData} = getActions(activeTab);
const actions = computed(() => completedActionsData.value?.actions ?? []);
const completedByFilter = computed(() => store.getters['actions/completedByFilter']);

const toggleCompletedByFilter = (name) => store.dispatch('actions/toggleCompletedByFilter', name);

watch(actions, () => {
  let completedBy =  _(actions.value)
    .flatMap(action => [
      {
        name: action.pending_completed_by,
        id: action.pending_completed_by_id,
        active: _.find(completedByFilter.value, filter => filter?.name === action.pending_completed_by)?.active ?? true
      }
    ])
    .uniqBy('name')
    .sortBy('name')
    .value();

  store.dispatch('actions/setCompletedByFilter', completedBy);
}, {
  immediate: true,
});

const monthOptions = [
  {value: 1, label: '1 month'},
  {value: 3, label: '3 months'},
  {value: 6, label: '6 months'},
  {value: 12, label: '12 months'},
];
</script>

<template>
  <div class="tw-flex tw-justify-between">
    <div class="tw-flex tw-gap-6 tw-items-center">
      <div
        v-if="completedByFilter?.length > 0"
        class="tw-self-start tw-text-sm tw-font-bold tw-text-grey-dark tw-pt-3"
      >
        Show:
      </div>
      <div class="tw-flex tw-flex-wrap tw-gap-2">
        <PillCheckbox
          v-for="filter in completedByFilter"
          :key="filter.name"
          :active="filter.active"
          @click="toggleCompletedByFilter(filter.name)"
        >
          {{ filter.name ?? 'Unknown' }}
        </PillCheckbox>
      </div>
    </div>
    <CustomMultiselect
      id="month"
      v-model="monthsFilter"
      class="tw-text-left tw-min-w-[224px] tw-self-start"
      :close-on-select="true"
      :options="monthOptions"
    />
  </div>
</template>

